<div class="popup-container" [ngClass]="statusClass">
  <img class="popup-status-icon" [src]="iconPath" alt="status icon"/>
  <div class="popup-content">
    <h2 class="popup-title">
      {{ titleKey ? (titleKey | translate) : title }}
    </h2>
    <p class="popup-message">
      {{ messageKey ? (messageKey | translate) : message }}
    </p>

    <div *ngIf="isConfirmation" class="popup-actions">
      <app-button (click)="closePopup(false)"
                  [label]="'shared.close' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="ButtonState.REGULAR"
                  [type]="ButtonType.SECONDARY"
      ></app-button>
      <app-button (click)="closePopup(true)"
                  [label]="'shared.confirm' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="ButtonState.REGULAR"
                  [type]="status === 'warning' ? ButtonType.ERROR : ButtonType.PRIMARY"
      ></app-button>
    </div>

    <div *ngIf="!isConfirmation" class="popup-actions">
      <app-button *ngIf="!isBackToLogin" (click)="closePopup()"
                  [label]="'shared.close' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="ButtonState.REGULAR"
                  [type]="ButtonType.PRIMARY"
      ></app-button>

      <app-button *ngIf="isBackToLogin" (click)="backtoLogin()"
                  [label]="'shared.back_login' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="ButtonState.REGULAR"
                  [type]="ButtonType.PRIMARY"
      ></app-button>
    </div>
  </div>
</div>
